import React from "react";
import { useDispatch } from "react-redux";
import { logout } from "../redux/Slice/authSlice";
import { logout as logoutRequest } from "../services/auth";
import ChangePasswordForm from "../components/ChangePasswordForm";
import "./admin.css";
import OwnezzyLogo from "../components/OwnezzyLogo";

// Shown instead of the panel while the account still uses a temporary password
export default function ChangePassword() {
  const dispatch = useDispatch();
  const signOut = async () => {
    await logoutRequest().catch(() => {});
    dispatch(logout());
  };
  return (
    <div className="login-shell">
      <div className="login-card">
        <div className="login-logo"><OwnezzyLogo wide /></div>
        <h1>Choose a new password</h1>
        <p>You signed in with a temporary password. Set your own before continuing.</p>
        <ChangePasswordForm />
        <button className="text-btn" onClick={signOut}>Sign out</button>
      </div>
    </div>
  );
}
